import React, { useEffect, useRef, useState } from "react";
import { CMSEPGEvent } from "../../../../models/CMS/cmsEPGEvent";
import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import styled from "styled-components";
import { ITableSetting } from "../../../Table/BasicTable";
import { MdModeEditOutline } from "react-icons/md";
import noImage from "../../../../../resources/missing-img.png";
import { useNavigate } from "react-router-dom";
import { IconWrapper, ImageWrapper } from "./TableSettingsComponents";

const EPGTableWrapper = styled(Table)`
  .body-row:hover {
    cursor: pointer;
  }

  .live {
    background-color: #b6ff9e;
  }

  .catchup {
    background-color: #dedede;
  }

  .future {
    background-color: #cfdbff;
  }
`;

const EPGTableSettings: ITableSetting<CMSEPGEvent>[] = [
  {
    id: "image-id",
    align: "left",
    name: "",
    path: "gg",
    content: (data: CMSEPGEvent) => (
      <ImageWrapper>
        <div
          className="image"
          style={{
            backgroundImage: `url(${data.getImage() || noImage})`,
          }}
        />
      </ImageWrapper>
    ),
  },
  {
    id: "EPGEventId",
    align: "left",
    name: "EPGEventId",
    path: "EPGEventId",
    content: (data: CMSEPGEvent) => <div>{data.epgEventId}</div>,
  },
  {
    id: "programId",
    align: "left",
    name: "programId",
    path: "programId",
    content: (data: CMSEPGEvent) => <div>{data.getProgramTitle()}</div>,
  },
  {
    id: "start",
    align: "left",
    name: "start",
    path: "start",
    content: (data: CMSEPGEvent) => <div>{data.startScheduled}</div>,
  },
  {
    id: "end",
    align: "left",
    name: "end",
    path: "end",
    content: (data: CMSEPGEvent) => <div>{data.endScheduled}</div>,
  },
  {
    id: "edit-id",
    align: "right",
    name: "",
    path: "gh",
    content: (data: CMSEPGEvent) => (
      <IconWrapper>
        <MdModeEditOutline />
      </IconWrapper>
    ),
  },
];

interface EPGTableProps {
  EPG?: CMSEPGEvent[];
}

const Container = styled.div``;

export const EPGTable: React.FC<EPGTableProps> = (props) => {
  const { EPG = [] } = props;
  const componentRef = useRef<HTMLTableRowElement | null>(null);
  const history = useNavigate();

  useEffect(() => {
    componentRef.current &&
      componentRef.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
  }, [EPG]);

  // improve this logic to find live program
  const isProgramLive = (index: number) => {
    if (index === 19) return true;
    return false;
  };

  const getProgramStatus = (index: number) => {
    if (index === 17) return "live";
    else if (index < 17) return "catchup";
    else return "future";
  };

  const redirect = (id) => {
    history(`/cms/assets/${id}`);
  };

  return (
    <>
      <Container>
        {(EPG.length && (
          <EPGTableWrapper stickyHeader aria-label="sticky table">
            <TableBody style={{ position: "relative" }}>
              {EPG.map((event: CMSEPGEvent, index) => {
                return (
                  <TableRow
                    className={`body-row ${getProgramStatus(index)}`}
                    hover
                    key={event.epgEventId + "tableKey"}
                    ref={isProgramLive(index) ? componentRef : undefined}
                    onClick={() => redirect(event.assetId)}
                  >
                    {EPGTableSettings.map((column, index) => (
                      <TableCell key={column.id} align={column.align}>
                        {column.content(event, index)}
                      </TableCell>
                    ))}
                  </TableRow>
                );
              })}
            </TableBody>
          </EPGTableWrapper>
        )) || <></>}
      </Container>
    </>
  );
};
